import CancelDelayedOrderModal from './CancelDelayedOrderModal';

export default CancelDelayedOrderModal;